// extracted by mini-css-extract-plugin
export default {"container":"VerifyEmailPage_container__y3yUb","header":"VerifyEmailPage_header__SlWzz","content-container":"VerifyEmailPage_content-container__iox47"};